const uncertainMessage = 'Zuordnung noch nicht bestätigt. Bitte nicht erneut hochladen. Scans aktualisieren oder den Verarbeitungsstand prüfen.';

// Keep an uncertain operation in the caller's map: a second click only reads its status.
export async function assignScanWithRecovery({ apiUrl, token, scanId, payload, pending,
  fetchFn = fetch, makeId = () => crypto.randomUUID(), sleep = (ms) => new Promise(r => setTimeout(r, ms)),
  now = Date.now, onChecking = () => {}, pollLimit = 30, requestTimeout = 25000 }) {
  const key = `${scanId}:${payload.customer_id}`;
  let requestId = pending.get(key);
  const request = async (url, options, timeout) => {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), timeout);
    try {
      const response = await fetchFn(url, { ...options, signal: controller.signal });
      let data;
      try { data = JSON.parse(await response.text()); } catch { throw new Error(uncertainMessage); }
      if (!response.ok) {
        const error = new Error(data.error || uncertainMessage);
        error.definite = [400, 401, 403, 404, 409, 422].includes(response.status);
        throw error;
      }
      return data;
    } finally { clearTimeout(timer); }
  };
  const headers = { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` };
  if (!requestId) {
    requestId = makeId();
    pending.set(key, requestId);
    try {
      const data = await request(`${apiUrl}/admin/scans/${scanId}/assign`, {
        method: 'POST', headers, body: JSON.stringify({ ...payload, assignment_request_id: requestId }),
      }, requestTimeout);
      if (!data.assignment?.scan_file_id) throw new Error(uncertainMessage);
      pending.delete(key);
      return data;
    } catch (error) {
      if (error.definite) { pending.delete(key); throw error; }
    }
  }
  onChecking();
  const deadline = now() + 90000;
  for (let attempt = 0; attempt < pollLimit && now() < deadline; attempt += 1) {
    let data;
    try {
      data = await request(`${apiUrl}/admin/scan-assignments/${encodeURIComponent(requestId)}?customer_id=${encodeURIComponent(payload.customer_id)}`,
        { method: 'GET', headers, cache: 'no-store' }, 5000);
    } catch { /* Missing status is not proof of failure. Never repeat the upload. */ }
    if (data?.status === 'assigned' && data.assignment?.scan_file_id) {
      pending.delete(key); return data;
    }
    if (data?.status === 'review_required') throw new Error(data.message || uncertainMessage);
    if (attempt + 1 < pollLimit && now() < deadline) await sleep(2000);
  }
  throw new Error(uncertainMessage);
}
